
import { defineComponent, computed } from 'vue'
import FormInput from '@/components/organisms/dms/common/FormInput.vue'

export default defineComponent({
  name: 'UserInfo',
  components: {
    FormInput
  },
  props: {
    modelValue: {
      type: Object
    },
    requiredCheck: {
      type: Boolean
    }
  },
  setup (props, { emit }) {
    const state = computed({
      get: () => props.modelValue,
      set: (state) =>
        emit('update:modelValue', state)
    })
    return {
      props,
      state
    }
  }
})
